export default "__VITE_ASSET__BMS3H_Vi__"